module.exports = __webpack_public_path__ + "img/bitcoin_payments.c0d88a80.webp";